import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { WifiOff } from "lucide-react";
import Header from "@/components/Header";
import Sidebar from "@/components/Sidebar";
import { useOnline } from "@/hooks/useOnline";
import { useDashboardData, DashboardContext } from "@/context/DashboardContext";
import { HEADER } from "@/constants/testIds";

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const online = useOnline();
  const dash = useDashboardData();

  return (
    <DashboardContext.Provider value={dash}>
      <div className="min-h-screen flex flex-col bg-background">
        {!online && (
          <div
            data-testid={HEADER.offlineBanner}
            className="bg-amber-500 text-black text-sm font-medium px-4 py-2 flex items-center justify-center gap-2"
          >
            <WifiOff className="h-4 w-4" /> You're offline. Showing the runbooks already loaded; changes can't be saved
            until you reconnect.
          </div>
        )}
        <Header onToggleSidebar={() => setSidebarOpen(true)} />
        <div className="flex flex-1 w-full max-w-[1600px] mx-auto">
          <Sidebar
            meta={dash.meta}
            filters={dash.filters}
            setFilter={dash.setFilter}
            clearFilters={dash.clearFilters}
            reload={dash.reload}
            open={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
          <main className="flex-1 min-w-0 p-4 sm:p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </DashboardContext.Provider>
  );
}
